import { ReactNode } from 'react'
import { AppShell } from '@workwhile/web-ui'
import { Outlet } from 'react-router-dom'
import { ErrorBoundary } from 'components/ErrorBoundary'
import { SideNav } from './SideNav'
import { MobileTopNav } from './MobileTopNav'

interface ShellProps {
  /** Shown above the page, on every route */
  banner?: ReactNode
}

/** The app's navbar and page panel. Each route wraps its page in its own layout */
export const Shell = (props: ShellProps) => {
  return (
    <AppShell navbar={<SideNav />} header={<MobileTopNav />}>
      {props.banner}
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </AppShell>
  )
}
